import { nextTick } from 'vue';
import { useStore } from 'vuex';

import { prefillAddressBE, prefillAddressFR } from '@mixins/form/prefill-address';
import { getParameters } from '@mixins/quiz/history';
import { fillWorktypeId, storeAnswer } from '@mixins/quiz/v2.0.0/checks';
import { getNextQuestion } from '@mixins/quiz/v2.0.0/get-next-question';
import { goToQuestion } from '@mixins/quiz/v2.0.0/go-to-question';
import { addExtraData } from '@mixins/quiz/v2.0.0/question';
import stripHtml from '@mixins/utils/strip-html';

export const handleFirstQuestion = () => {
    const store = useStore();
    let answer = getParameters()['first_question'];

    if (!answer) return;

    answer = decodeURIComponent(answer);

    const firstQuestion = store.state.quiz.questionsData[0];
    let nextQuestion = 'next_question';

    if (!firstQuestion) return;

    const questionType = firstQuestion._info.type;

    if (firstQuestion.answers) {
        const matchedQuestion = firstQuestion.answers.find(a => a.ELMO_value.value === answer);

        if (matchedQuestion && matchedQuestion.next_question?.value) {
            nextQuestion = matchedQuestion.next_question.value;
        }

        if (matchedQuestion?.worktype_id_override?.value) {
            fillWorktypeId(matchedQuestion.worktype_id_override.value);
        }
    }

    // Handle custom logic for specific question types here
    switch (questionType) {
    case 'zipcode':
        handleZipcodeQuestion(answer);
        break;
    }

    nextQuestion = getNextQuestion(nextQuestion, 1);

    const alias = firstQuestion.lead_service_name.value || 'extradata-question-1';

    storeAnswer(alias, answer);
    addExtraData(alias, {
        name: alias,
        question: stripHtml(firstQuestion.text.value),
        value: answer,
        label: answer,
    });

    goToQuestion(null, nextQuestion, null);

    return nextQuestion;
}

const handleZipcodeQuestion = answer => {
    const store = useStore();

    store.commit('form/setPrefillZipcode', answer);
    store.commit('user/setLocationValue', { key: 'zipcode', value: answer });

    nextTick(() => {
        if (store.state.page.countryCode === 'be') {
            prefillAddressBE();
        }

        if (store.state.page.countryCode === 'fr') {
            prefillAddressFR();
        }
    });
}
